import { apiClient } from 'modules/api-client';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useRouteUserBasedOnAuthenticationStrategy = (
  redirectTo?: string | null,
) => {
  const navigate = useNavigate();

  return useCallback(
    async (email: string) => {
      const { strategy, userExists } =
        await apiClient.user.getAuthenticationStrategy(email);
      switch (strategy.type) {
        case 'sso': {
          const { identityProvider, organizationId } = strategy;
          const params = new URLSearchParams({
            email,
            provider: identityProvider,
            organizationId: String(organizationId),
            userExists: String(userExists),
          });
          if (redirectTo) {
            params.set('r', redirectTo);
          }
          navigate(`/login/sso?${params.toString()}`);
          return;
        }
        case 'password': {
          const params = new URLSearchParams({
            email,
            userExists: String(userExists),
          });
          if (redirectTo) {
            params.set('r', redirectTo);
          }
          navigate(
            `${userExists ? '/login/password' : '/signup/freetrial'}?${params.toString()}`,
          );
          return;
        }
        default: {
          const unexpectedStrategy: never = strategy;
          console.warn(
            `Unknown authentication strategy type: ${(unexpectedStrategy as { type: string }).type}`,
          );
        }
      }
    },
    [navigate, redirectTo],
  );
};
